// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__95WMY","notes":"Notes_notes__1BdMW"};